import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'scheduler/preview/main';

export const useSchedulerPreviewQuery = ({
	impersonationContext,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return new Promise<string>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: 'scheduler/preview/main',
						impersonationContext,
					}),
					'GET',
					null,
					async response => {
						resolve(await response.text());
					},
					error => {
						reject(error);
					}
				);
			});
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext],
	});
};

export const invalidateSchedulerPreviewQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
